export function removeExtraListItems<T>(list: T[], maxCount: number): T[] {
  if (list.length > maxCount) {
    return list.slice(0, maxCount);
  }

  return list;
}
